query gradeLevels ($teamId: ID!) {
  gradeLevels(teamId: $teamId) {
    canCurrentDelete
    name
    color {
      id
      name
      displayName
    }
    icon {
      id
      name
      displayName
    }
    id
    order
    orderDenominator
    orderNumerator
    studentCount
    team {
      id
      name
    }
  }
}
